/*
  Zoom images load last, but are ready when clicked.

  The closed zoom modal is display:none (section-main-product.css), so its lazy
  images no longer load with the page. This script loads them on purpose:
  - after the page has loaded and the browser is idle: only the zoom image of
    the active gallery image, at low priority;
  - on hover, focus or pointerdown of a gallery image: that image's zoom image,
    at high priority.
  The idle preload is skipped when the visitor asked to save data or is on a
  2G connection. Without this script the zoom image still loads when the modal
  opens, because it keeps loading="lazy".
*/
(() => {
  if (window.__zoomPreload) return; // quick add can inject the section scripts again
  window.__zoomPreload = true;

  const connection = navigator.connection; // missing in Firefox and Safari: treated as unconstrained
  const constrained = !!(connection && (connection.saveData || /2g/.test(connection.effectiveType || '')));

  const zoomImageFor = (opener) => {
    const modal = document.querySelector(opener.dataset.modal);
    const toggle = opener.querySelector('.product__media-toggle');
    const id = toggle && toggle.dataset.mediaId;
    return modal && id ? modal.querySelector(`img[data-media-id="${id}"]`) : null;
  };

  const promote = (img, priority) => {
    if (!img || img.loading === 'eager') return;
    img.fetchPriority = priority;
    img.loading = 'eager'; // lazy to eager starts the fetch, also inside a display:none modal
  };

  const whenIdle = (fn) =>
    'requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 3000 }) : setTimeout(fn, 1500);

  const idlePreload = () => {
    if (constrained) return;
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      const opener =
        gallery.querySelector('.product__media-item.is-active modal-opener') ||
        gallery.querySelector('.product__media-item:not(.color-group-hidden) modal-opener');
      if (opener) promote(zoomImageFor(opener), 'low');
    });
  };

  if (document.readyState === 'complete') whenIdle(idlePreload);
  else window.addEventListener('load', () => whenIdle(idlePreload), { once: true });

  const onIntent = (event) => {
    const opener = event.target.closest && event.target.closest('modal-opener[data-modal^="#ProductModal-"]');
    if (!opener) return;
    if (constrained && event.type !== 'pointerdown') return;
    promote(zoomImageFor(opener), 'high');
  };
  document.addEventListener('pointerover', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent);
  document.addEventListener('pointerdown', onIntent, { passive: true });

  // product-info.js replaces the modal content before it publishes variantChange,
  // so the new (lazy again) zoom images exist when this runs.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => whenIdle(idlePreload));
  }
})();
